import { easeInOutSine } from './easing';

export const lerp = (src: number[], target: number[], progress: number) => {
  let x = easeInOutSine(progress);
  return src.map((v, i) => {
    if (target[i] === v) return v;
    let diff = target[i] - v;
    let val = v + diff * x;
    if (Math.abs(target[i] - val) < 1) val = target[i];
    return val;
  });
};
